export default __webpack_public_path__ + "static/media/1415knife block A side.be93aa03.png";